import { media, spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-background-full";
const padding = {
  padding: `${spacing["2xl"]} 0`,
  [`@media (${media.queries.tablet.min})`]: {
    padding: `${spacing["6xl"]} 0`
  },
  [`@media (${media.queries.highDef})`]: {
    padding: `${spacing["8xl"]} 0`
  }
};
function composeFull(options) {
  const { theme = "light" } = options || {};
  let backgroundColor;
  let deprecatedAliases = [];
  if (theme === "light") {
    backgroundColor = color.gray.lightest;
    deprecatedAliases.push("umd-layout-background-color");
  } else {
    backgroundColor = color.black;
    deprecatedAliases.push("umd-layout-background-color-dark");
  }
  const className = `${classNamePrefix}-${theme}`;
  return objectWithClassName({
    ...padding,
    backgroundColor,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const light = composeFull({ theme: "light" });
const dark = composeFull({ theme: "dark" });
export {
  composeFull,
  dark,
  light,
  padding
};
//# sourceMappingURL=full.js.map
